"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterIcon = exports.DateFilterDropdown = exports.BasicFilterDropdown = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SearchOutlined_1 = __importDefault(require("@ant-design/icons/lib/icons/SearchOutlined"));
var button_1 = __importDefault(require("antd/es/button"));
var input_1 = __importDefault(require("antd/es/input"));
var dayjs_1 = __importDefault(require("rc-picker/lib/generate/dayjs"));
var generatePicker_1 = __importDefault(require("antd/es/date-picker/generatePicker"));
var tableExtensionsUtils_1 = require("./tableExtensionsUtils");
var DatePicker = (0, generatePicker_1.default)(dayjs_1.default);
var RangePicker = DatePicker.RangePicker;
var BasicFilterDropdown = function (_a) {
    var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
    return (react_1.default.createElement(DropWrap, null,
        react_1.default.createElement(DropDown, null,
            react_1.default.createElement(InputArea, { placeholder: "Search", value: selectedKeys[0], onChange: function (e) {
                    return setSelectedKeys(e.target.value ? [e.target.value] : []);
                }, onPressEnter: confirm }),
            react_1.default.createElement(button_1.default, { type: "primary", onClick: function () {
                    return confirm({ closeDropdown: true });
                }, icon: react_1.default.createElement(SearchOutlined_1.default, null) }, "Search"),
            react_1.default.createElement(button_1.default, { onClick: clearFilters }, "Reset"))));
};
exports.BasicFilterDropdown = BasicFilterDropdown;
var DateFilterDropdown = function (_a) {
    var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters, dateFormat = _a.dateFormat;
    return (react_1.default.createElement(DropWrap, null,
        react_1.default.createElement(DropDown, null,
            react_1.default.createElement(RangePickerArea, { value: selectedKeys[0] ? (0, tableExtensionsUtils_1.decodeDateRange)(selectedKeys[0]) : undefined, allowEmpty: [true, true], onChange: function (_dates, dateStrings) {
                    // there seems to be a Table bug where it doesn't truly accept multiple values in a way that allows for filtering.
                    // To get around it, we'll just put all the data in one string and deal with parsing.
                    setSelectedKeys([
                        (0, tableExtensionsUtils_1.encodeDateRange)(dateFormat, dateStrings[0], dateStrings[1]),
                    ]);
                } }),
            react_1.default.createElement(button_1.default, { type: "primary", onClick: function () {
                    return confirm({ closeDropdown: true });
                }, icon: react_1.default.createElement(SearchOutlined_1.default, null) }, "Search"),
            react_1.default.createElement(button_1.default, { onClick: clearFilters }, "Reset"))));
};
exports.DateFilterDropdown = DateFilterDropdown;
// re-exporting here to keep it in the same area as the other table-date related functions
__exportStar(require("./tableExtensionsUtils"), exports);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var SearchIcon = (0, styled_components_1.default)(function (_a) {
    var filtered = _a.filtered, rest = __rest(_a, ["filtered"]);
    return react_1.default.createElement(SearchOutlined_1.default, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &&& {\n        color: ", ";\n    }\n"], ["\n    &&& {\n        color: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme, filtered = _a.filtered;
    return filtered
        ? theme.palette.secondary.default.toString()
        : theme.palette.primary.default.toString();
});
var DropWrap = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 300px;\n"], ["\n    width: 300px;\n"])));
var DropDown = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    padding: ", ";\n    gap: ", ";\n"], ["\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    padding: ", ";\n    gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.sm.toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.sm.toString();
});
var InputArea = (0, styled_components_1.default)(input_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    grid-column: 1 / span 2;\n"], ["\n    grid-column: 1 / span 2;\n"])));
var RangePickerArea = (0, styled_components_1.default)(RangePicker)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    grid-column: 1 / span 2;\n"], ["\n    grid-column: 1 / span 2;\n"])));
var FilterIcon = function (filtered) { return (react_1.default.createElement(SearchIcon, { filtered: filtered, alt: "Filter Column" })); };
exports.FilterIcon = FilterIcon;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=tableExtensions.js.map